import { Dispatch } from 'react';
import { TeamRequestAction, renderStack } from '.';
import { IDeaNumUser, ValueLabel } from '../common';

export const UserRolesStack = ({
  deaNumUsers,
  selectedUserRoleKeys,
  dispatchTeamRequest,
  properties,
}: {
  deaNumUsers: IDeaNumUser[];
  selectedUserRoleKeys: string[];
  dispatchTeamRequest: Dispatch<TeamRequestAction>;
  properties: ValueLabel<keyof IDeaNumUser>[];
}) =>
  renderStack(properties)({
    selectedUserRoleKeys,
    dispatchTeamRequest,
  })(deaNumUsers);
